module.exports = __webpack_public_path__ + "files/45d73ff9e038c03d7ede46fe8383c76d.png";